module.exports = __webpack_public_path__ + "static/media/003.6d8d1e95.jpg";